import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.devices')
  .factory('DevicesAPI', DevicesAPI);

function DevicesAPI(): BringozApi {
  return {
    base: `/devices`,
    infiniteScroll: {
      address: `/devices`,
      cmd: 'GET'
    },
    actions: {
      getDevices: {
        address: '',
        cmd: 'GET',
        updateable: true
      }
    }
  }
}
